'use client';

import React from 'react';
import { MdOutlineChevronLeft, MdOutlineChevronRight } from 'react-icons/md';
import { useSpringCarousel } from 'react-spring-carousel';
import Image from 'next/image';
import Button from '@ui/Button';
import getQualifiedImageUrl from '@utils/imageUrlProcessor';
import { size } from 'lodash-es';
import { cx } from 'cva';

function PostImages({ imageUrls, message = null, bgColor = null }) {
  const showNavigation = size(imageUrls) > 1;

  const { carouselFragment, slideToPrevItem, slideToNextItem } =
    useSpringCarousel({
      items: imageUrls.map((url, index) => {
        return {
          id: url,
          renderItem: (
            <div className="relative aspect-video w-full overflow-hidden">
              <Image
                src={getQualifiedImageUrl(url)}
                alt={message || 'Post Image'}
                fill
                className={cx(
                  'object-contain',
                  bgColor ? `${bgColor}` : 'bg-black',
                )}
                sizes="(max-width: 768px) 100vw,
                      (max-width: 1200px) 50vw,
                      33vw"
              />
            </div>
          ),
        };
      }),
      itemsPerSlide: 1,
      withLoop: true,
    });

  return (
    <div className="relative flex h-full w-full items-center justify-start">
      <div className="h-full w-full flex-1 overflow-hidden">
        {carouselFragment}
      </div>
      {showNavigation && (
        <>
          <div className="absolute left-1 top-1/2 -translate-y-1/2">
            <Button
              variant="icon"
              onClick={slideToPrevItem}
              className="!bg-body-background !p-1 opacity-60 hover:opacity-90">
              <MdOutlineChevronLeft className="h-6 w-6" />
            </Button>
          </div>
          <div className="absolute right-1 top-1/2 -translate-y-1/2">
            <Button
              variant="icon"
              onClick={slideToNextItem}
              className="!bg-body-background !p-1 opacity-60 hover:opacity-90">
              <MdOutlineChevronRight className="h-6 w-6" />
            </Button>
          </div>
        </>
      )}
    </div>
  );
}

export default PostImages;
